import { createSelector } from '@reduxjs/toolkit';
import { currentEmployeeUuid } from 'src/store/selectors';
import { currentContactUuid } from 'src/store/selectors';
import { emergencyAccessList } from 'src/store/selectors/emergency/emergency-access-list';

export const emergencyAccess = createSelector(
  currentEmployeeUuid,
  currentContactUuid,
  emergencyAccessList,
  function (currentEmployeeUuid, currentContactUuid, accessList) {
    const userUuid = currentEmployeeUuid ?? currentContactUuid;
    if (userUuid === undefined) return false;
    return accessList.includes(userUuid);
  },
);
